/* SaltyCells — First-order discount capture ($30 off, code delivered by email)
   Slide-in bar. Shows after 15s OR 40% scroll, whichever comes first.
   - Never shows on preorder / thank-you / contact pages (competing CTAs)
   - Suppressed 7 days after dismissal, forever after signup
   - Posts to Netlify form "discount" (hidden static registration lives in index.html)
   - The submission-created function then emails the code via Brevo
*/
(function () {
  var SKIP_PAGES = ['/pages/preorder', '/pages/thank-you', '/pages/contact'];
  var DELAY_MS = 15000;
  var SCROLL_PCT = 0.4;
  var DISMISS_DAYS = 7;

  var path = window.location.pathname;
  for (var i = 0; i < SKIP_PAGES.length; i++) {
    if (path.indexOf(SKIP_PAGES[i]) !== -1) return;
  }
  try {
    if (localStorage.getItem('sc_disc_done')) return;
    var dismissed = parseInt(localStorage.getItem('sc_disc_dismissed') || '0', 10);
    if (dismissed && Date.now() - dismissed < DISMISS_DAYS * 864e5) return;
  } catch (e) { /* private browsing — just show */ }

  var shown = false;

  function injectStyles() {
    var s = document.createElement('style');
    s.textContent = [
      '#sc-disc{position:fixed;left:50%;bottom:-160px;transform:translateX(-50%);z-index:8500;width:min(560px,calc(100% - 2rem));background:#0a1a32;border:1px solid rgba(0,229,176,0.35);border-radius:14px;padding:1.1rem 1.3rem;box-shadow:0 12px 40px rgba(0,0,0,0.5);transition:bottom 0.45s cubic-bezier(.2,.8,.3,1);}',
      '#sc-disc.visible{bottom:1.25rem;}',
      '#sc-disc-close{position:absolute;top:8px;right:12px;background:none;border:none;color:#8ab4d4;font-size:18px;cursor:pointer;line-height:1;}',
      '#sc-disc-close:hover{color:#fff;}',
      '#sc-disc h3{color:#fff;font-size:1.05rem;margin:0 0 0.25rem;}',
      '#sc-disc h3 em{color:#00e5b0;font-style:normal;}',
      '#sc-disc p{color:#8ab4d4;font-size:0.82rem;margin:0 0 0.75rem;line-height:1.45;}',
      '#sc-disc-form{display:flex;gap:0.5rem;}',
      '#sc-disc-form input[type=email]{flex:1;min-width:0;background:#060f1e;border:1px solid rgba(0,200,255,0.25);border-radius:8px;color:#fff;padding:0.6rem 0.8rem;font-size:0.9rem;outline:none;}',
      '#sc-disc-form input[type=email]:focus{border-color:#00c8ff;}',
      '#sc-disc-form button{background:linear-gradient(90deg,#00e5b0,#00c8ff);color:#060f1e;font-weight:700;border:none;border-radius:8px;padding:0.6rem 1rem;font-size:0.9rem;cursor:pointer;white-space:nowrap;}',
      '#sc-disc-form button:hover{opacity:0.88;}',
      '#sc-disc .sc-disc-fine{font-size:0.68rem;margin:0.55rem 0 0;color:#5f7f9e;}',
      '#sc-disc-ok{display:none;text-align:center;padding:0.4rem 0;}',
      '#sc-disc-ok strong{color:#00e5b0;display:block;font-size:1rem;margin-bottom:0.2rem;}',
      '#sc-disc-ok span{color:#8ab4d4;font-size:0.82rem;}',
      '@media(max-width:480px){#sc-disc-form{flex-direction:column;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function injectHTML() {
    var div = document.createElement('div');
    div.id = 'sc-disc';
    div.innerHTML = [
      '<button id="sc-disc-close" aria-label="Close">&times;</button>',
      '<div id="sc-disc-wrap">',
      '  <h3>Get <em>$30 off</em> your first battery</h3>',
      '  <p>Join the list and we\'ll email your discount code instantly.</p>',
      '  <form id="sc-disc-form">',
      '    <input type="hidden" name="form-name" value="discount">',
      '    <input type="text" name="bot-field" style="display:none" tabindex="-1" autocomplete="off">',
      '    <input type="email" name="email" placeholder="you@email.com" required aria-label="Email address">',
      '    <button type="submit">Email my code</button>',
      '  </form>',
      '  <p class="sc-disc-fine">One code per customer. No spam &mdash; unsubscribe anytime.</p>',
      '</div>',
      '<div id="sc-disc-ok"><strong>&#10003; Code on its way!</strong><span>Check your inbox in the next minute or two.</span></div>'
    ].join('');
    document.body.appendChild(div);

    document.getElementById('sc-disc-close').addEventListener('click', function () {
      hide();
      try { localStorage.setItem('sc_disc_dismissed', String(Date.now())); } catch (e) {}
    });

    document.getElementById('sc-disc-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(this);
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(data).toString()
      }).catch(function () { /* Netlify may still have received it */ });
      document.getElementById('sc-disc-wrap').style.display = 'none';
      document.getElementById('sc-disc-ok').style.display = 'block';
      try { localStorage.setItem('sc_disc_done', '1'); } catch (e) {}
      if (typeof fbq !== 'undefined') fbq('track', 'Lead');
      if (typeof gtag !== 'undefined') gtag('event', 'generate_lead', { method: 'discount_capture' });
      setTimeout(hide, 4000);
    });
  }

  function show() {
    if (shown) return;
    // Don't fight the pre-order modal if it's open
    var overlay = document.getElementById('sc-overlay');
    if (overlay && overlay.classList.contains('visible')) {
      setTimeout(show, 8000);
      return;
    }
    shown = true;
    var el = document.getElementById('sc-disc');
    if (el) requestAnimationFrame(function () { el.classList.add('visible'); });
  }

  function hide() {
    var el = document.getElementById('sc-disc');
    if (el) el.classList.remove('visible');
  }

  function onScroll() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= SCROLL_PCT) {
      window.removeEventListener('scroll', onScroll);
      show();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectStyles();
    injectHTML();
    setTimeout(show, DELAY_MS);
    window.addEventListener('scroll', onScroll, { passive: true });
  });
})();
